import { render, staticRenderFns } from "./HowToSchema.vue?vue&type=template&id=e34b9c78"
import script from "./HowToSchema.vue?vue&type=script&lang=js"
export * from "./HowToSchema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports